import { render, staticRenderFns } from "./CardText.vue?vue&type=template&id=7c1b0ff4&scoped=true"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"
import style0 from "./CardText.vue?vue&type=style&index=0&id=7c1b0ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b0ff4",
  null
  
)

export default component.exports